/* hush-pdp-header.js — toggle del nav mobile + cart count sync */
(function(){
  'use strict';

  function $$(sel, root){ return Array.prototype.slice.call((root||document).querySelectorAll(sel)); }
  function $1(sel, root){ return (root||document).querySelector(sel); }

  function initDrawer(header){
    var toggle = $1('[data-hush-nav-toggle]', header);
    var nav = $1('[data-hush-nav]', header.parentElement);
    var backdrop = $1('[data-hush-nav-backdrop]', header.parentElement);
    if (!toggle || !nav) return;

    function setOpen(open){
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      nav.classList.toggle('is-open', open);
      if (backdrop) backdrop.classList.toggle('is-open', open);
      document.body.style.overflow = open ? 'hidden' : '';
    }

    toggle.addEventListener('click', function(){
      setOpen(toggle.getAttribute('aria-expanded') !== 'true');
    });
    if (backdrop) backdrop.addEventListener('click', function(){ setOpen(false); });
    document.addEventListener('keydown', function(e){
      if (e.key === 'Escape') setOpen(false);
    });
    // Cerrar al clicar un link
    $$('.hush-pdp__nav-link', nav).forEach(function(a){
      a.addEventListener('click', function(){
        // Si no tiene submenu, cerrar
        if (!a.parentElement.classList.contains('hush-pdp__nav-item--has-children')) setOpen(false);
      });
    });
  }

  function applyCartCount(count){
    $$('[data-hush-cart-count]').forEach(function(el){
      var n = parseInt(count, 10) || 0;
      el.textContent = String(n);
      if (n === 0) el.setAttribute('data-empty', '1');
      else el.removeAttribute('data-empty');
    });
  }

  function syncCartCount(){
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function(r){ return r.json(); })
      .then(function(c){ applyCartCount((c && c.item_count) || 0); })
      .catch(function(){});
  }

  function init(){
    $$('[data-hush-pdp-header]').forEach(initDrawer);
    // Sync inicial + listeners de eventos de carrito
    setTimeout(syncCartCount, 250);
    var evts = ['cart:added','cart:updated','cart:refresh','shopify:cart:refresh',
                'upcart:cart:updated','upcart:cart:added','ajaxProduct:added'];
    evts.forEach(function(n){
      document.addEventListener(n, syncCartCount);
      window.addEventListener(n, syncCartCount);
    });
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
